// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b7ec9f91","455":"3e7cbe0f","977":"88e3be93"}[chunkId] + ".chunk.js";
};